"use client";
import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  VStack,
  HStack,
  Stack,
  Button,
  Spinner,
  Flex,
  Input,
} from "@chakra-ui/react";
import HeaderTools from "../../components/HeaderTools";
import api from "../../services/api";
import { toast } from "react-toastify";

export default function Clients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [search, setSearch] = useState("");

  const handleToggleStatus = (clientId) => {
    setClients((prevClients) =>
      prevClients.map((client) =>
        client.id === clientId
          ? {
              ...client,
              status: client.status === "liberado" ? "liberar" : "liberado",
            }
          : client
      )
    );
  };

  useEffect(() => {
    const getClients = async () => {
      try {
        setLoading(true);
        const response = await api.get("/clients");
        setClients(response.data);
      } catch {
        toast.error(
          "Não foi possível buscar os seus clientes, entre em contato com o suporte."
        );
      } finally {
        setLoading(false);
      }
    };

    getClients();
  }, []);

  return (
    <>
      <HeaderTools
        title="Clientes"
        onClickSearch={() => setShowSearch((prev) => !prev)}
        showSearch
      />
      <Box
        padding={{ base: "16px", md: "20px" }}
        bg="gray.50"
        minHeight="100vh"
      >
        <Text fontSize={{ base: "14px", md: "16px" }} color="gray.600" mb={4}>
          {clients.length} clientes
        </Text>
        <Stack
          direction="column"
          spacing={3}
          mb={6}
          display={{ base: "flex", md: "none" }}
        >
          <Box
            bg="white"
            p={3}
            borderRadius="6px"
            border="1px solid"
            borderColor="gray.200"
            cursor="pointer"
            _hover={{ bg: "gray.50" }}
          >
            <Text fontSize="16px" color="gray.700">
              Perfil
            </Text>
          </Box>

          <Box
            bg="white"
            p={3}
            borderRadius="6px"
            border="1px solid"
            borderColor="gray.200"
            cursor="pointer"
            _hover={{ bg: "gray.50" }}
          >
            <Text fontSize="16px" color="gray.700">
              Documento
            </Text>
          </Box>

          <Box
            bg="white"
            p={3}
            borderRadius="6px"
            border="1px solid"
            borderColor="gray.200"
            cursor="pointer"
            _hover={{ bg: "gray.50" }}
          >
            <Text fontSize="16px" color="gray.700">
              Origem
            </Text>
          </Box>

          <Box
            bg="white"
            p={3}
            borderRadius="6px"
            border="1px solid"
            borderColor="gray.200"
            cursor="pointer"
            _hover={{ bg: "gray.50" }}
          >
            <Text fontSize="16px" color="gray.700">
              Status
            </Text>
          </Box>
        </Stack>
        <HStack
          spacing={4}
          mb={6}
          display={{ base: "none", md: "flex" }}
          flexWrap="wrap"
        >
          <Box
            bg="white"
            p={3}
            borderRadius="6px"
            border="1px solid"
            borderColor="gray.200"
            cursor="pointer"
            _hover={{ bg: "gray.50" }}
            minW="120px"
          >
            <Text fontSize="16px" color="gray.700">
              Perfil
            </Text>
          </Box>

          <Box
            bg="white"
            p={3}
            borderRadius="6px"
            border="1px solid"
            borderColor="gray.200"
            cursor="pointer"
            _hover={{ bg: "gray.50" }}
            minW="140px"
          >
            <Text fontSize="16px" color="gray.700">
              Documento
            </Text>
          </Box>

          <Box
            bg="white"
            p={3}
            borderRadius="6px"
            border="1px solid"
            borderColor="gray.200"
            cursor="pointer"
            _hover={{ bg: "gray.50" }}
            minW="120px"
          >
            <Text fontSize="16px" color="gray.700">
              Origem
            </Text>
          </Box>

          <Box
            bg="white"
            p={3}
            borderRadius="6px"
            border="1px solid"
            borderColor="gray.200"
            cursor="pointer"
            _hover={{ bg: "gray.50" }}
            minW="120px"
          >
            <Text fontSize="16px" color="gray.700">
              Status
            </Text>
          </Box>
        </HStack>
        {showSearch && (
          <Input
            placeholder="Pesquisar..."
            backgroundColor="white"
            padding="15px"
            onChange={(e) => setSearch(e.target.value)}
            marginBottom="25px"
          />
        )}
        <VStack spacing={0} align="stretch">
          {loading && (
            <Flex width="100%" justify="center">
              <Spinner />
            </Flex>
          )}
          {clients
            .filter((client) =>
              client.name.toLowerCase().includes(search.toLowerCase())
            )
            .map((client, index) => (
              <Box
                key={client.id}
                bg="white"
                p={{ base: 4, md: 6 }}
                cursor="pointer"
                _hover={{ bg: "gray.50" }}
                transition="background 0.2s"
                borderBottom={
                  index < clients.length - 1 ? "1px solid #e0e0e0" : "none"
                }
                borderRadius={
                  index === 0
                    ? "8px 8px 0 0"
                    : index === clients.length - 1
                    ? "0 0 8px 8px"
                    : "0"
                }
              >
                <HStack justify="space-between" align="center">
                  <VStack align="start" spacing={1} flex="1">
                    <HStack spacing={2} align="center">
                      <Box w="8px" h="8px" borderRadius="50%" bg="green.500" />
                      <Text
                        fontWeight="bold"
                        fontSize={{ base: "16px", md: "18px" }}
                        color="gray.800"
                      >
                        {client.name}
                      </Text>
                    </HStack>
                    <Text
                      fontSize={{ base: "14px", md: "15px" }}
                      color="gray.600"
                      ml="18px"
                    >
                      {client.email}
                    </Text>
                    <Text
                      fontSize={{ base: "14px", md: "15px" }}
                      color="gray.600"
                      ml="18px"
                    >
                      {client.cpf_cnpj}
                    </Text>
                  </VStack>

                  {/*   <Button
                  size={{ base: "sm", md: "md" }}
                  bg={client.status === "liberado" ? "white" : "black"}
                  color={client.status === "liberado" ? "black" : "white"}
                  border="1px solid"
                  borderColor={
                    client.status === "liberado" ? "gray.300" : "black"
                  }
                  _hover={{
                    bg: client.status === "liberado" ? "gray.50" : "gray.800",
                  }}
                  fontSize={{ base: "12px", md: "14px" }}
                  px={{ base: 3, md: 4 }}
                  onClick={() => handleToggleStatus(client.id)}
                >
                  {client.status === "liberado" ? "Liberado" : "Liberar"}
                </Button>*/}
                </HStack>
              </Box>
            ))}
        </VStack>

        {clients.length === 0 && (
          <Box textAlign="center" py={10}>
            <Text color="gray.500" fontSize={{ base: "14px", md: "16px" }}>
              Nenhum cliente encontrado.
            </Text>
          </Box>
        )}
      </Box>
    </>
  );
}
